// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';
import { setCookie } from '../../../js/lib/cookies';

function GlobalAlerts(el) {
  const ui = {
    el,
    dismiss: select('.js-dismiss', el),
    allAlerts: select.all('.global-alert', el),
    container: select('.global-alerts', document),
  };

  const dismissContainer = () => {
    if (ui.container) {
      ui.container
        .animate([
          { transform: "scaleY(1)", transformOrigin: "top" },
          { transform: "scaleY(0)", transformOrigin: "top" }
        ], { duration: 100, fill: 'forwards' })
        .onfinish = () => {
          ui.container.remove();
        };
    }
  }

  const getAlertCounts = () => {
    let totalAlertCount = select.all('.global-alert', ui.container).length;

    if (totalAlertCount === 0) {
      dismissContainer();
    }
  }

  const COOKIE_NAME = ui.el.id;

  const addEvents = () => {
    ui.dismiss.addEventListener('click', () => {
      // hide this alert
      const computedStyle = window.getComputedStyle(ui.el);
      const paddingTop = computedStyle.paddingTop;
      const paddingBottom = computedStyle.paddingBottom;

      const dismissAnimation = [
        { opacity: 1 },
        {
          opacity: 0,
          height: `${ui.el.scrollHeight}px`,
          paddingTop,
          paddingBottom,
        },
        { opacity: 0, height: '0', paddingTop: '0', paddingBottom: '0' },
      ];

      ui.el
        .animate(dismissAnimation, { duration: 250, fill: 'forwards' })
        .onfinish = () => {
          // Remove the alert from the DOM after animation completes
          ui.el.remove();

          getAlertCounts();
        };

      // set this alerts cookie
      const alertTimestamp = ui.el.getAttribute('data-alert-timestamp');
      setCookie(COOKIE_NAME, alertTimestamp, 30);
    });
  }

  const init = () => {
    addEvents();
  };

  init();
}

export default GlobalAlerts;
